import DataTableCreateDefinitionHelper from "./DataTableCreateDefinitionHelper";
import ViewTTStore from "../ViewTTStore";
import PDFImageCache from "../../../pdf/PDFImageCache";
import UserTime from "../../../user_time";
import messageResource from "../../../messageResource";
import LeaveTypeStore from "../../../store/LeaveTypeStore";
import {atImgPath} from "../../../atBrowserUtils";
import {PDFDefinitionBuilderParameters} from './PDFDefinitionBuilder'
import {PaperOrientation, PaperSize} from '../../../pdf/constants'
import PDFDefinitionBuilder from './PDFDefinitionBuilder'
import _ from 'underscore'

const PDFDefinitionCreator = function(parameterFormatter) {};

PDFDefinitionCreator.prototype = _.create(PDFDefinitionCreator.prototype, {

    createDocDefinition: function(pdfConfig, parameterFormatter)
    {
        this.parameterFormatter = parameterFormatter;
        this.pdfPrintParams = pdfConfig.pdfPrintParameters;
        this.pdfData = pdfConfig.pdfData;
        this.pdfConfig = pdfConfig;

        var ddb = new PDFDefinitionBuilder();
        ddb.init(this.pdfPrintParams.paperOrientation, this.pdfPrintParams.paperSize);

        // start create doc definition
        return PDFImageCache
                .preloadImages(this._imagesMap(pdfConfig)) // preload needed images
                .then(
                        _.bind(this._processCreateDocDefinition, this, ddb) // construct doc definition
                )
                .then(function()
                      {
                          // return object for generate pdf
                          return {
                              "docDefinition": ddb.getDocDefinitionObject(),
                              "tableLayouts": ddb.getTableLayouts()
                          }
                      });
    },

    _imagesMap: function()
    {
        var imagesMap = {
            "logo": {
                "url": window.__GENERATED_CONSTANTS__.REPORT_LOGO_PATH
            },
            "openTask": {
                "url": atImgPath('workflow/open-big.png'),
                "saveAlpha": true
            },
            "completedTask": {
                "url": atImgPath('workflow/completed-big.png'),
                "saveAlpha": true
            },
            "lockedDay": {
                "url": atImgPath('lock_tt/lock-icon.png'),
                "saveAlpha": true
            },
            "filterIcon": {
                "url": atImgPath('filter-for-pdf.png'),
                "saveAlpha": true
            }
        };
        var leaveTypesIds = _.map(LeaveTypeStore.getLeaveTypes(), function(leaveType)
        {
            return leaveType["iconId"];
        });
        _.each(leaveTypesIds, function(id)
        {
            imagesMap["leaveTypeIcon_" + id] = {
                "url": getLeaveTypeIconPath(id)
            };
        });

        return imagesMap;
    },

    _processCreateDocDefinition: function(ddb)
    {
        ddb.initDocDefinitionObject(this.pdfPrintParams.showSignatureOnEachPage && this.pdfPrintParams.showSignature, this.pdfPrintParams.showHeaderOnEachPage);

        var headerData = this._createHeaderData();
        if (this.pdfPrintParams.paperOrientation == PaperOrientation.PORTRAIT)
        {
            ddb.addPortraitHeader(this.pdfPrintParams.showHeaderOnEachPage, this.pdfPrintParams.showLogoInHeader, headerData);
        }
        else
        {
            ddb.addLandscapeHeader(this.pdfPrintParams.showHeaderOnEachPage, this.pdfPrintParams.showLogoInHeader, headerData)
        }

        this.addTotals(ddb);

        if (this.pdfConfig.getChartSectionConfig.showChart && this.pdfData.chartImage != null)
        {
            var viewByText = messageResource.getMessage('view_tt.chart.view_by_label');
            viewByText += " " + ViewTTPageUtils.getChartTypeMessage(this.pdfConfig.getChartSectionConfig.chartType);
            ddb.addChartImage(viewByText, this.pdfData.chartImage);
        }

        this._addTableData(ddb);

        if (this.pdfPrintParams.showSignature && !this.pdfPrintParams.showSignatureOnEachPage)
        {
            ddb.addSignatureToEnd();
        }
        ddb.addFooterWithSignature(this.pdfPrintParams.showSignatureOnEachPage && this.pdfPrintParams.showSignature);
    },

    addTotals: function(ddb)
    {
        var storedData = this.pdfConfig.storedData;
        var dateStr = this.formatDateSelection(this.pdfConfig.selectedParameters.dateParameters.dateRangeSelection);

        var leaveTimeTotals = [];
        ViewTTPageUtils.leaveTotalsOrderedIterate(storedData["leaveTimeTotals"], function(leaveType, leaveTime)
        {
            leaveTimeTotals.push({name: leaveType["name"], value: UserTime.formatTimeWithDigitSeparator(leaveTime)});
        });

        var totalSpentVal = ViewTTPageUtils.calculateTotalSpent(storedData);
        var totalSpent = UserTime.formatTimeWithDigitSeparator(totalSpentVal);
        var totalWorkingTimeVal = storedData["totalWorking"];
        var totalWorkingTime = UserTime.formatTimeWithDigitSeparator(totalWorkingTimeVal);
        var effectiveDuration = (!_.isNull(storedData["effectiveDuration"])) ? UserTime.formatTimeWithDigitSeparator(storedData["effectiveDuration"]) : null;
        var totalDiffVal = 0;
        if (!_.isNull(storedData["effectiveDuration"]))
        {
            totalDiffVal = totalSpentVal - storedData.effectiveDuration;
        }

        if (!_.isNull(storedData['totalWorkingForToday']))
        {
            var totalSpentForTodayVal =  ViewTTPageUtils.calculateTotalSpentForToday(storedData);
            var totalSpentForToday = UserTime.formatTimeWithDigitSeparator(totalSpentForTodayVal);
            var effectiveDurationForToday = (!_.isNull(storedData['effectiveDurationForToday'])) ?
                                            UserTime.formatTimeWithDigitSeparator(storedData["effectiveDurationForToday"]) : null;
            if (!_.isNull(storedData["effectiveDurationForToday"]))
            {
                totalDiffVal = totalSpentForTodayVal - storedData.effectiveDurationForToday;
            }

        }
        var showLeaves = storedData.totalLeaveTime !== null;
        var showOvertime = storedData["totalOvertimeInfo"] !== null;

        var showSecondColumn = showOvertime || showLeaves;
        var totalsBuilder = ddb.getTotalElementBuilder(totalSpent, effectiveDuration, totalSpentForToday, effectiveDurationForToday, totalDiffVal, dateStr, showSecondColumn);

        if (showSecondColumn)
        {
            totalsBuilder.appendSecondColumn(showLeaves);
        }

        totalsBuilder.appendTotalWorkingTime(totalWorkingTime);

        if (showOvertime)
        {
            var ovtValue = storedData["totalOvertimeInfo"]["reported"];
            var autoValue = storedData["totalOvertimeInfo"]["auto"];
            if(_.isNull(ovtValue))
            {
                ovtValue = autoValue;
            }

            if(!_.isNull(ovtValue))
            {
                var regularWorkingTime = UserTime.formatTimeWithDigitSeparator(totalWorkingTimeVal - ovtValue);
                totalsBuilder.appendRegularWorkingTime(regularWorkingTime);
                var totalOvertime = UserTime.formatTimeWithDigitSeparator(ovtValue);
                totalsBuilder.appendTotalOvertime(totalOvertime);
            }
            
            if (!_.isNull(autoValue) && ovtValue != autoValue)
            {
                var totalAutoOvertime = UserTime.formatTimeWithDigitSeparator(autoValue);
                totalsBuilder.appendTotalAutoOvertime(totalAutoOvertime);
            }
        }

        if (showLeaves)
        {
            var totalLeaveTime = UserTime.formatTimeWithDigitSeparator(storedData["totalLeaveTime"]);
            totalsBuilder.appendTotalLeaveTime(totalLeaveTime, leaveTimeTotals);
        }
        totalsBuilder.build();
    },

    formatDateSelection: function(dateSelection)
    {
        return (new ViewTTPage.TotalsForPeriod()).formatDateQualifier(dateSelection.qualifier);
    },

    getChartImageSizes: function(pdfPrintParameters)
    {
        var pdfParameters = PDFDefinitionBuilderParameters;
        if (pdfPrintParameters.paperOrientation == PaperOrientation.LANDSCAPE)
        {
            pdfParameters = pdfParameters.Landscape;
        }
        else
        {
            pdfParameters = pdfParameters.Portrait;
        }

        if (pdfPrintParameters.paperSize == PaperSize.A4)
        {
            pdfParameters = pdfParameters.A4;
        }
        else
        {
            pdfParameters = pdfParameters.Letter;
        }

        return {
            width: pdfParameters.chartImageSize.width * 2,
            height: pdfParameters.chartImageSize.height * 2
        }
    },

    _createHeaderData: function()
    {
        var selectedParameters = this.pdfConfig.selectedParameters;
        return {
            informationTexts: {
                title: this.parameterFormatter.formatChartPDFHeaderTitle(selectedParameters),
                dateRange: this.parameterFormatter.formatChartPDFHeaderDateInformation(selectedParameters)
            },
            filterTexts: this.parameterFormatter.formatChartPDFFilterInformation(selectedParameters),
            logo: PDFImageCache.getImage('logo')
        }
    },

    _addTableData: function(ddb)
    {
        new DataTableCreateDefinitionHelper(ddb, this.pdfData.tableData, {
            viewByDays: this.pdfConfig.selectedParameters.viewByDays,
            showTasks: this.pdfConfig.selectedParameters.showTasks,
            dateFormat: ViewTTStore.getDateFormat()
        }).createTable();
    }
    
});

export default PDFDefinitionCreator;


// WEBPACK FOOTER //
// ./web/js/user/viewtt/pdf/PDFDefinitionCreator.js